import type React from 'react';
import { useMemo } from 'react';

import { Grid } from '@mui/material';
import { getCoreRowModel, type TableOptions, useReactTable } from '@tanstack/react-table';

import EnhancedTable from 'components/tables/enhancedTable/EnhancedTable';
import { type PersonEventEligibility } from 'typedefs/event';

import { useEligibilityTableColumns } from './utils';

const getRowId = (row) => row.participantId;

interface EligibilityRulesTableProps {
  participantsEligibility: PersonEventEligibility[];
}

const EligibilityRulesTable: React.FC<React.PropsWithChildren<EligibilityRulesTableProps>> = ({
  participantsEligibility,
}) => {
  const tableColumns = useEligibilityTableColumns();

  const options: TableOptions<PersonEventEligibility> = useMemo(
    () => ({
      columns: tableColumns,
      data: participantsEligibility,
      getRowId: getRowId,
      getCoreRowModel: getCoreRowModel(),
    }),
    [tableColumns, participantsEligibility],
  );

  const tableInstance = useReactTable<PersonEventEligibility>(options);
  const rows = tableInstance.getRowModel().rows;

  return (
    <Grid container item padding={2}>
      <EnhancedTable columnsToggle={false} id="person-eligibility-table" rows={rows} tableInstance={tableInstance} />
    </Grid>
  );
};

export default EligibilityRulesTable;
